import axios from "axios";
import { Enviroments } from "../enviroments/enviroments";

const BRAND_SLUG = "esportiva";

const api = axios.create({
  baseURL: Enviroments.API_URL_LOTOGREEN,
  headers: {
    "Content-Type": "application/json",
    "X-Brand-Slug": BRAND_SLUG
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("apiToken");
  const cookieKey = localStorage.getItem("cookieKey");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  if (cookieKey) {
    config.headers["X-Cactus-Cookie-Key"] = cookieKey;
  }

  return config;
});

export const cactusApi = {
  // Auth
  login: (credentials) => api.post("api/auth/login", credentials),
  logout: (cookie_key) => api.post("api/auth/logout", { cookie_key }),
  getUser: () => api.get("api/auth/user"),

  // Depósito
  createDeposit: (amount) => api.post("api/deposit", { amount }),
  getDepositStatus: (transactionId) => api.get(`api/deposit/${transactionId}/status`),

  // Jogo
  startGame: ({ slug, platform = "WEB", use_demo = 0 }) => 
    api.get(`api/start-game?slug=${encodeURIComponent(slug)}&platform=${platform}&use_demo=${use_demo}`)
};

export default api;
